/*
 *  CommentStore.js
 *
 *
 *
 */
//==============================================================================
// External dep.
//==============================================================================
import _ from "lodash";
import logger from "../utils/LoggerFrontend";
import Reflux from "reflux";
//==============================================================================
// Intenral
//==============================================================================
import Actions from "../Actions";
//==============================================================================
// External dep.
//==============================================================================
export default class CommentStore extends Reflux.Store {
  constructor() {
    super();
    logger.debug("CommentStore:constructor", "called");

    this.state = {
      campaignComments: undefined
    }; // <- set stores default state much like in React
    this.listenables = Actions;
  }
  onToggleAtsView() {
    this.setState({
      showAtsView: !this.state.showAtsView
    });
  }
  onFetchAllComments() {
    this.setState({
      campaignComments: null
    });
  }
  onDeleteCommentCompleted(orgaId, campaignId, commentId) {
    var comments = this.state.campaignComments;
    if (this.state.campaignComments) {
      logger.log("CommentStore:onDeleteCommentCompleted", "called..: ", { commentId });
      comments = _.filter(this.state.campaignComments, (comment) => {
        return comment.id !== commentId;
      });
    }

    this.setState({
      campaignComments: comments
    });
  }
  onStoreCommentWithoutEmailAndNotificationCompleted(
    orgaId,
    campaignId,
    comment,
    username,
    userrole,
    userId,
    commentId,
    meta
  ) {
    logger.debug("CommentStore:onStoreCommentWithoutEmailAndNotificationCompleted", "called..: ", {
      orgaId,
      campaignId,
      comment,
      username,
      userrole,
      userId,
      commentId,
      meta
    });
    this.onStoreCommentCompleted(
      orgaId,
      campaignId,
      comment,
      username,
      userrole,
      userId,
      commentId
    );
  }
  onStoreCommentCompleted(orgaId, campaignId, comment, username, userrole, userId, commentId) {
    logger.debug(
      "CommentStore:onStoreCommentCompleted",
      "called..: ",
      comment,
      userrole,
      this.state.campaignComments
    );
    var comments = [];

    const commentData = {
      comment: comment,
      userName: username,
      createDate: +new Date(),
      userrole: userrole,
      userId: userId,
      id: commentId
    };

    if (!this.state.campaignComments) {
      comments = [commentData];
    } else {
      comments = this.state.campaignComments;
      comments.push(commentData);
    }

    logger.debug("CommentStore:onStoreCommentCompleted", "called..: ", comments);

    this.setState({
      campaignComments: comments
    });
  }

  onFetchAllCommentsCompleted(comments) {
    logger.debug(
      "CommentStore:onFetchAllCommentsCompleted",
      "called.. Nr of comments: ",
      comments && comments.length
    );
    this.setState({
      campaignComments: comments
    });
  }
}
